<template>
    <div>
        <div
            v-if="loading"
            class="form-spinner"
        >
            <span class="fa fa-spinner fa-lg fa-pulse" />
        </div>
        <div>
            <div>
                <div class="row">
                    <div class="col col-md-12">
                        <v-select 
                            ref="vselect"
                            v-model="text"
                            placeholder=""
                            :multiple="true"
                            :options="hints"
                            :filterable="false"
                            :clear-search-on-select="true"
                            :close-on-select="true"
                            @search="loadHints"
                            @input.native="loadAllHints($event)"
                            @click.native="loadAllHints($event)"
                            @input="emitChange"
                        >
                            <span slot="no-options">Ничего не найдено</span>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ClauseMixin from './ClauseMixin.vue';

    export default { 
        name: 'PropertyField',
        mixins: [ClauseMixin],
        props: {
            type: {
                type: String,
                default: 'customProperty',
            }, 
            propertykey: {
                type: String,
                default: '',
            }
        },
        data: function() {
            return { 
                text: this.content.text,
                timeout: null,
                hints: [],
                emptyhints: [],
            }
        },
        watch: { 
            propertykey: function(newVal, oldVal) { // watch it
                if(newVal !== oldVal) {
                    this.loadEmptyHints();
                }
            }
        },
        mounted: function() {
            this.loadEmptyHints();
        },
        methods: {
            loadEmptyHints: function() {
                let cmp = this;
                $.ajax({
                    type: "POST",
                    url: '/properties/'+cmp.siteid+'/'+cmp.propertykey+'/hint/?q=',
                    success: function ( data ) {
                        cmp.hints = data.hints;
                        cmp.emptyhints= data.hints;
                    },
                    error: function(error) {
                    }
                });
            },
            loadHints: function(text, loading) {
                let cmp = this;
                clearTimeout(cmp.timeout);
                loading(true);
                cmp.timeout = setTimeout(function() {
                    $.ajax({
                        type: "POST",
                        url: '/properties/'+cmp.siteid+'/'+cmp.propertykey+'/hint/?q='+encodeURIComponent(text),
                        success: function ( data ) {
                            cmp.hints = data.hints;
                            loading(false);
                        },
                        error: function(error) {
                            loading(false);
                        }
                    });
                }, 100);
            },
            loadAllHints: function(e) {
                if (!this.$refs.vselect.$refs.search.value) {
                    this.hints = this.emptyhints;
                }
            },
            emitChange: function() {
                this.$emit('change', {
                    'id': this.id,
                    'clause': '', 
                    'text': this.text || [],
                    'type': this.content.type,
                    'sum': 0,
                });
            },
        }
    }
</script>
